module.exports = "/img/commercial_vehicle.9e4b61ee.png";